import { useDialog } from "./useDialog";

interface ProgressModalProps {
  title: string;
  message: string;
  progress: number;
}

export function ProgressModal({ title, message, progress }: ProgressModalProps): JSX.Element {
  const dialogRef = useDialog<HTMLDivElement>(true);
  const percent = Math.max(0, Math.min(100, Math.round(progress * 100)));
  return (
    <div className="dialog-backdrop" role="presentation">
      <div ref={dialogRef} className="dialog" role="dialog" aria-modal="true" aria-labelledby="progress-title" tabIndex={-1}>
        <div className="dialog__body">
          <h2 id="progress-title">{title}</h2>
          <p className="helper" aria-live="polite">
            {message}
          </p>
          <progress className="progress-native" value={percent} max={100}>
            {percent}%
          </progress>
        </div>
      </div>
    </div>
  );
}
